module.exports = __webpack_public_path__ + "static/Montserrat-500-0098f804fc2d06af52650e0b8ed3390c.ttf";